import { SVGProps } from 'react'

import { cn } from '@/shared/lib'

import { ICON, type RoomIconName } from './icon'

type Props = SVGProps<SVGSVGElement> & {
  name: RoomIconName
  size?: number | string
}

export const RoomIcon = ({
  name,
  size = '100%',
  width,
  height,
  strokeWidth = 1,
  className,
  ...restProps
}: Props) => {
  const IconComponent = ICON[name]

  return (
    <IconComponent
      width={width || size}
      height={height || size}
      className={cn('shrink-0', className)}
      strokeWidth={strokeWidth}
      {...restProps}
    />
  )
}
